/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api\index.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Provisioning Device Models module.
────────────────────────────────────────────────────────────────*/

import { api } from '../../../lib/api';

export interface Vendor {
    id: number;
    uuid?: string;
    name: string;
}

export interface DeviceModel {
    id: number;
    uuid?: string;
    vendorId: number;
    vendor?: Vendor;
    modelName: string;
    model?: string;

    // JSON configuration fields
    maxAccounts: number;
    maxDssKeys: number;
    supportsExpansionUnits: boolean;
    maxExpansionUnits: number;
    expModuleKeys?: number;
    expansionUnitModels?: unknown;
    supportedDssTypes?: string[];
    supportedTemplateTypes?: string[];

    accounts?: unknown;
    phonebook?: unknown;
    keys?: unknown;
    timezone?: unknown;
    language?: unknown;
    wallpaper?: boolean;
    openvpn?: unknown;
    blfpressSettings?: unknown;
    ringtones?: boolean;
    buttonIcons?: unknown;
    dndBlfServerSync?: unknown;
    daylightSavings?: unknown;
    timeFormat?: unknown;
    dateFormat?: unknown;
    expansionModuleKeys?: unknown;
    summerTime?: unknown;

    // Files
    imageFile?: string;
    templateFile?: string;    // Path to base template file (extension determines format)
    firmware?: string;
    variablesJson?: string[];
    isSystem?: boolean;
}

// API Functions
export const getDeviceModels = () => api.get<DeviceModel[]>('/api/apps/provisioning/device-models').then(res => res.data);
export const getDeviceModel = (id: number | string) => api.get<DeviceModel>(`/api/apps/provisioning/device-models/${id}`).then(res => res.data);
export const deleteDeviceModel = (id: number | string) => api.delete(`/api/apps/provisioning/device-models/${id}`);

export const createDeviceModel = (data: FormData) => {
    return api.post('/api/apps/provisioning/device-models', data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }).then(res => res.data);
};

export const updateDeviceModel = (id: number | string, data: FormData) => {
    return api.put(`/api/apps/provisioning/device-models/${id}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    }).then(res => res.data);
};

export const duplicateDeviceModel = (id: number | string) => {
    return api.post<DeviceModel>(`/api/apps/provisioning/device-models/${id}/duplicate`).then(res => res.data);
};

// Also need Vendor API for the form
export const getVendors = () => api.get<Vendor[]>('/api/apps/provisioning/vendors').then(res => res.data);
